// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore"
import {getAuth} from "firebase/auth"
import {collection, addDoc, doc, setDoc, orderBy, onSnapshot, refEqual} from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAyGwdgvzf-geGgRIx__dh-lg3TR4fg6v0",
  authDomain: "edward-ndlovu.firebaseapp.com",
  projectId: "edward-ndlovu",
  storageBucket: "edward-ndlovu.appspot.com",
  messagingSenderId: "837173761467",
  appId: "1:837173761467:web:bf0e06330057a15645e09e",
  measurementId: "G-9LTE28S0NX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app)
//const db = app.getFirestore()
const auth = getAuth (app)

export {db, auth, collection, addDoc, doc, setDoc, orderBy, onSnapshot}